<div>
  <div nz-dropdown nzTrigger="click" class="dropdown" [nzDropdownMenu]="menu">
    <nz-badge [nzCount]="badgeCount">
      <nz-avatar nzIcon="user" [nzShape]="'square'" [nzSize]="'large'" class="avatar"></nz-avatar>
    </nz-badge>
  </div>
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu>
      <li nz-menu-item>
        <strong>{{ 'topBar.profileMenu.activeUser' | translate }} {{name || 'Anonymous'}}</strong>
      </li>
      <li nz-menu-divider></li>
      <li nz-menu-item>
        <a href="javascript: void(0);" (click)="editProfile()">
					<i-feather name="user" class="mr-2"></i-feather>
          {{ 'topBar.profileMenu.editProfile' | translate }}
        </a>
      </li>
      <li nz-menu-divider></li>
      <li nz-menu-item>
        <a href="javascript: void(0);" (click)="logout()">
					<i-feather name="log-out" class="mr-2"></i-feather>
          {{ 'actions.logout' | translate }}
        </a>
      </li>
    </ul>
  </nz-dropdown-menu>
</div>
